export default {
  username: "Username",
  clickToUpload: "Click to upload",
  imageFormats: "PNG, JPG up to 10MB",
  scanning: "Scanning...",
  or: "or",
  cancel: "Cancel",
  errors: {
    invalidFileType: "Invalid file type",
    pleaseSelectImageFile: "Please select a valid image file (JPG or PNG)",
    cameraError: "Camera access error",
    pleaseAllowCamera: "Please allow camera access to scan products",
    scanError: "Scan error",
    pleaseTryAgain: "Please try again",
    noImageSelected: "No image selected",
    noTextDetected: "No text detected",
    pleaseTryDifferentImage: "Please try with a different image",
    visionApiError: "Error processing image"
  }
};